import { route, tag, type PageTour } from '../pageTour';

export const attendanceTimelineTour: PageTour = {
  id: 'page-attendance-timeline',
  version: 1,
  title: 'Timeline',
  summary: 'Each person\'s day: arrivals, departures and breaks.',
  match: route('/attendance/timeline'),
  steps: [
    {
      target: tag('attendance-timeline-date'),
      title: 'Work date',
      description: 'Choose the day whose ins and outs you want to see.',
      side: 'right',
    },
    {
      target: tag('attendance-timeline-camera'),
      title: 'Camera',
      description: 'Limit the timeline to the movements one camera saw.',
      side: 'right',
    },
    {
      target: tag('attendance-toolbar'),
      title: 'Inside now',
      description: 'How many people are inside right now, and how many have gaps in their in and out pattern that need a look.',
      side: 'bottom',
    },
    {
      target: tag('attendance-table'),
      title: 'In and out log',
      description: 'Each person\'s ins, outs and time on site for the day. Expand a row to see every sighting.',
      side: 'top',
    },
  ],
};
